import React from 'react';
import { Row, Col, DatePicker } from 'antd';
import BaseDailyPage from '../../common/baseDailyPage';
import Header from '../../common/dailyHeader';
import MembersWidget from './members.js';
import PointsEarnedWidget from './pointsEarned.js';
import OvercomingWidget from './overcoming.js';
import GuestCardActivitiesWidget from './guestCardActivities.js';
import GoalsAndAveragesWidget from './goalsAndAverages.js';
import FastingWidget from './fasting.js';
import PrayingWidget from './praying.js';
import GroupComparisonWidget from './groupComparison.js';
import WidgetContainer from '../../common/widgetContainer';
import { revivalPhaseCountdown } from "../../../../../utilities/churchRevival";

export default class DailyPage extends BaseDailyPage {
  get widgetParams() {
    return {
      churchId: this.props.selectedChurch.id,
      timezone: this.props.selectedChurch.timezone,
      periodStartTime: this.periodStartDate.unix(),
      periodEndTime: this.periodEndDate.unix()
    }
  }

  get header() {
    return (
      <Row className="statistics-page-header-row">
        <Col size={24} className="statistics-page-header-with-filter">
          <div className="statistics-page-header">
            <Header {...this.widgetParams} revivalStartDate={this.props.revivalWeeks.church.revival.startDate}/>
          </div>
          <DatePicker disabledDate={this.disabledDate} value={this.periodStartDate}
                      onChange={this.onDayChange} format={this.dateFormat}/>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <WidgetContainer header={this.header}>
        <MembersWidget {...this.widgetParams} position={{ xl: 0, lg: 0, md: 0 }} />
        <PointsEarnedWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <OvercomingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <GuestCardActivitiesWidget {...this.widgetParams} position={{ xl: 0, lg: 1, md: 0 }} />
        <GoalsAndAveragesWidget {...this.widgetParams} position={{ xl: 1, lg: 1, md: 0 }} />
        <FastingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <PrayingWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <GroupComparisonWidget {...this.widgetParams} position={{ xl: 2, lg: 1, md: 0 }} />
      </WidgetContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/daily.js